import type { JSX } from "react";
import type { CommonNavItemProps } from "./common-nav-item-props";
import { useSetting } from "../../../../services/services-context";
import { NavButton } from "./nav-button";


export type NavItemExternalLinkProps = CommonNavItemProps & {
	kind: "gaff";
	path: `/${string}`;
};
export const NavItemExternalLink = ({ path, icon, labelKey, slim }: NavItemExternalLinkProps): JSX.Element => {
	const url = useSetting("agentUrl");

	return (
		<NavButton
			labelKey={ labelKey }
			icon={ icon }
			href={ url + path }
			LinkComponent={ "a" }
			slim={ slim }
		/>
	);
};
